exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icrs-section-title[data-v-370aeee3]{margin:2rem}.icrs-section-title h3[data-v-370aeee3]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;white-space:nowrap}.icrs-section-title h3[data-v-370aeee3]:after{display:inline-block;content:\"\";background-color:var(--grey-light);height:4px;width:100%;margin-left:1rem;margin-top:calc(.5rem + 4px)}", ""]);

// exports
